import { render } from "./Index.vue?vue&type=template&id=01037a72"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Sector/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01037a72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01037a72', __exports__)) {
    console.log('reload')
    api.reload('01037a72', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=01037a72", () => {
    console.log('re-render')
    api.rerender('01037a72', render)
  })

}


export default __exports__